import { render, staticRenderFns } from "./Referrers.vue?vue&type=template&id=1c4e46f6"
import script from "./Referrers.vue?vue&type=script&lang=js"
export * from "./Referrers.vue?vue&type=script&lang=js"
import style0 from "./Referrers.vue?vue&type=style&index=0&id=1c4e46f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports